import {
  SafetyCertificateOutlined,
  ShoppingCartOutlined,
  StopOutlined,
  UserOutlined,
} from '@ant-design/icons'
import { Card, Col, Row, Spin, Statistic } from 'antd'
import { UserMeyRealOverview as UserMeyRealOverviewType } from 'Modules'
import { useEffect, useState } from 'react'

import { AppAdmin } from 'api/app-admin'
import { logError } from 'utils/logger'

const UserMeyRealOverview = () => {
  const [overview, setOverview] = useState<UserMeyRealOverviewType>({
    totalUsers: 0,
    verifiedUsers: 0,
    blockedUsers: 0,
    totalPTOPurchases: 0,
  })
  const [loading, setLoading] = useState(false)

  const getOverviewData = async () => {
    setLoading(true)
    try {
      const res = await AppAdmin.getUserMeyRealOverview()
      if (res?.data?.data) {
        setOverview(res.data.data)
      }
    } catch (error) {
      logError('Error fetching overview:', error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getOverviewData()
  }, [])

  return (
    <Row gutter={[16, 16]} className="user-mey-real-overview">
      <Col xs={24} sm={12} md={6}>
        <Card>
          <Spin spinning={loading}>
            <Statistic
              title="Total Users"
              value={overview.totalUsers}
              prefix={<UserOutlined />}
              valueStyle={{ color: '#1890ff' }}
            />
          </Spin>
        </Card>
      </Col>
      <Col xs={24} sm={12} md={6}>
        <Card>
          <Spin spinning={loading}>
            <Statistic
              title="Verified Users"
              value={overview.verifiedUsers}
              prefix={<SafetyCertificateOutlined />}
              valueStyle={{ color: '#52c41a' }}
            />
          </Spin>
        </Card>
      </Col>
      <Col xs={24} sm={12} md={6}>
        <Card>
          <Spin spinning={loading}>
            <Statistic
              title="Blocked Users"
              value={overview.blockedUsers}
              prefix={<StopOutlined />}
              valueStyle={{ color: '#ff4d4f' }}
            />
          </Spin>
        </Card>
      </Col>
      <Col xs={24} sm={12} md={6}>
        <Card>
          <Spin spinning={loading}>
            <Statistic
              title="Total PTO Purchases"
              value={overview.totalPTOPurchases}
              prefix={<ShoppingCartOutlined />}
              valueStyle={{ color: '#722ed1' }}
            />
          </Spin>
        </Card>
      </Col>
    </Row>
  )
}

export default UserMeyRealOverview
